export const signalStyles: Record<
  string,
  { tone: string; group: string; action: string }
> = {
  Blocked: {
    tone: "critical",
    group: "Delivery risk",
    action: "Review dependencies and agree an unblock owner.",
  },
  Overdue: {
    tone: "critical",
    group: "Delivery risk",
    action: "Confirm the deadline and recovery plan.",
  },
  "Review waiting": {
    tone: "warning",
    group: "Flow delay",
    action: "Assign a reviewer and clear the review queue.",
  },
  "No status movement": {
    tone: "warning",
    group: "Flow delay",
    action: "Check progress with the owner; update status when appropriate.",
  },
  "Small task ageing": {
    tone: "warning",
    group: "Flow delay",
    action: "Check hidden complexity, blockers or an outdated estimate.",
  },
  "Repeated carry-over": {
    tone: "warning",
    group: "Flow delay",
    action: "Re-plan or split the task with the team.",
  },
  "Missing estimate": {
    tone: "info",
    group: "Data gap",
    action: "Estimate the work with its owner in Linear, then sync.",
  },
  Unassigned: {
    tone: "info",
    group: "Data gap",
    action: "Assign an accountable owner in Linear, then sync.",
  },
};
export function estimateCoverage(estimated: number, total: number) {
  return total > 0 ? Math.round((estimated / total) * 100) : null;
}
export function knownWorkSprints(
  points: number,
  throughput: number | null,
  active: boolean,
  stale: boolean,
) {
  return active && !stale && throughput !== null && throughput > 0 && points > 0
    ? Math.ceil((points / throughput) * 10) / 10
    : null;
}
